import { z } from 'zod';


/**
 * Schema para actualizar área
 * 
 * Mismo esquema que crear área, ya que los campos son idénticos
 */
const updateAreaBaseSchema = z.object({
  code: z
    .string()
    .min(1, 'organization:validation.codeRequired')
    .max(30, 'organization:validation.codeMaxLength')
    .regex(
      /^[a-zA-Z0-9_-]+$/,
      'organization:validation.codeInvalidFormat',
    ),

  name: z
    .string()
    .min(1, 'organization:validation.nameRequired')
    .max(100, 'organization:validation.nameMaxLength'),

  parentAreaId: z.union([
    z.coerce
      .number({
        invalid_type_error: 'organization:validation.parentAreaInvalid',
      })
      .int('organization:validation.parentAreaInvalid')
      .positive('organization:validation.parentAreaInvalid'),
    z.null(),
  ]),
});

export const updateAreaSchema = updateAreaBaseSchema.refine(
  (data) => data.parentAreaId !== null,
  {
    message: 'organization:validation.parentAreaRequired',
    path: ['parentAreaId'],
  },
);

/**
 * Tipo inferido del schema de actualizar área
 */
export type UpdateAreaFormData = z.infer<typeof updateAreaSchema>;
